import request from '@/util/request'

export function generateShortUrl (data) {
  return request({
    url: '/noauth/shorturl/generate',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function listShortUrls () {
  return request({
    url: '/noauth/shorturl/list',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/shorturl.js